import { ScopeProvider } from 'jotai-scope';
import { ReactNode } from 'react';
import { tableAtoms } from '@/consts/scope';

export const TableScopeProvider = ({ children }: { children: ReactNode }) => (
  <ScopeProvider atoms={tableAtoms}>{children}</ScopeProvider>
);
